import { render, staticRenderFns } from "./BonusPoints.vue?vue&type=template&id=14256494&scoped=true&"
import script from "./BonusPoints.vue?vue&type=script&lang=js&"
export * from "./BonusPoints.vue?vue&type=script&lang=js&"
import style0 from "./BonusPoints.vue?vue&type=style&index=0&id=14256494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14256494",
  null
  
)

export default component.exports